import Vue from 'vue'
import VueRouter from 'vue-router'

import { routes } from './routesHome'

Vue.use(VueRouter)

const routerHome = new VueRouter({
  mode: "history",
  base: '/',
  routes,
  scrollBehavior() {
    return {x:0, y:0}
  }
})
// router.replace({path: '/vue/', redirect: '/'})
export { routerHome }
